import { render, staticRenderFns } from "./gamesSection.vue?vue&type=template&id=a038d55e&scoped=true"
import script from "./gamesSection.vue?vue&type=script&lang=js"
export * from "./gamesSection.vue?vue&type=script&lang=js"
import style0 from "./gamesSection.vue?vue&type=style&index=0&id=a038d55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a038d55e",
  null
  
)

export default component.exports